import { computed, unref, type Ref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import BucketLock from "@/services/bucket/bucket-lock";
import { BucketLockOverride } from "@/dtos/BucketLock.dto";

export interface BucketLockOverridesParams {
  organizationId: string;
}

export function useBucketLockOverrides(
  params: Ref<BucketLockOverridesParams | null> | BucketLockOverridesParams | null
) {
  const queryKey = computed(() => {
    const p = unref(params);
    if (!p) return ["bucketLockOverrides", "disabled"];
    return ["bucketLockOverrides", p.organizationId];
  });

  const enabled = computed(() => {
    const p = unref(params);
    return p !== null && p !== undefined && !!p.organizationId;
  });

  return useQuery({
    queryKey,
    queryFn: async (): Promise<BucketLockOverride[]> => {
      const p = unref(params);
      if (!p) throw new Error("Parameters not ready");

      const result = await BucketLock.getBucketLockOverrides({
        organizationId: p.organizationId,
      });

      let data = null;
      if (result.data?.status && result.data?.data) {
        data = result.data.data;
      } else if (result.data && !result.data.status) {
        data = result.data;
      }

      return data ?? [];
    },
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
